import {availableCountries} from './config'

export default function isMapAvailable(website, countryCode) {
  return availableCountries.includes(countryCode)
}
